// src/pages/Home.tsx
import React from "react";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import CTASection from "./CTASection";
import FooterSection from "./FooterSection";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Home: React.FC = () => {
  return (
    <HelmetProvider>
      <>
        <Helmet>
          <title>Tadwiro by Ayser World - Smart Construction Management Software</title>
          <meta
            name="description"
            content="Tadwiro is a modern SaaS-based construction management platform by Ayser World. Manage contracts, vehicles, payroll, attendance, tenders, and projects with ease."
          />
          <meta
            name="keywords"
            content="Tadwiro, Construction SaaS, Project Management, Ayser World, Contract Management, Vehicle Tracking, Payroll, Attendance"
          />
          <meta property="og:title" content="Tadwiro - Smart Construction Management by Ayser World" />
          <meta
            property="og:description"
            content="Tadwiro is your one-stop construction operations platform. Built for modern contractors to simplify project delivery."
          />
          {/* <meta property="og:image" content="https://firojalamkhan.com/assets/immages/firoj.jpeg" />
          <meta property="og:url" content="https://tadwiro.ayserworld.com" /> */}

          <script type="application/ld+json">
            {`
              {
                "@context": "http://schema.org",
                "@type": "Product",
                "name": "Tadwiro",
                "description": "SaaS-based construction management platform by Ayser World.",
                "brand": {
                  "@type": "Person",
                  "name": "AYSER WORLD"
                },
                "url": "https://tadwiro.ayserworld.com",
                "sameAs": [
                  "https://www.linkedin.com/in/firojalamkhan/",
                  "https://github.com/firojalamkhan"
                ]
              }
            `}
          </script>
        </Helmet>

        <main className="min-h-screen bg-gray-50 text-gray-800">
          <HeroSection />
          <FeaturesSection />
          <CTASection />
          <FooterSection />
        </main>
      </>
    </HelmetProvider>
  );
};

export default Home;